import type { PayloadAction } from '@reduxjs/toolkit'
import { createSelector, createSlice } from '@reduxjs/toolkit'
import type { RootState } from '@/store'

export type HederaSettingsState = {
  environment: 'evm' | 'hedera'
}

const initialState: HederaSettingsState = {
  environment: 'evm',
}

export const hederaSettingsSlice = createSlice({
  name: 'hederaSettings',
  initialState,
  reducers: {
    setEnvironment: (state, { payload }: PayloadAction<HederaSettingsState['environment']>) => {
      state.environment = payload
    },
  },
})

export const { setEnvironment } = hederaSettingsSlice.actions

export const selectHederaSettings = (state: RootState): HederaSettingsState => state[hederaSettingsSlice.name]

export const selectEnvironment = createSelector(selectHederaSettings, (settings) => settings.environment)
